import React, {PropTypes, Component} from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import _ from 'lodash';
import {Bar as BarChart} from 'react-chartjs'; //stacked bar? @see https://github.com/Regaddi/Chart.StackedBar.js/blob/master/src/Chart.StackedBar.js
import {colorsRGB} from 'app/globals';
import {serverToDisplayTimeSlot, serverDateFormat, displayDateFormat, displayToServerDate} from 'app/lib/format';
import Widget from '../../Widget';
import Preloader from 'routes/app/components/Preloader';
import Input from 'routes/app/components/Input';
import Col from 'routes/app/components/Col';
import Row from 'routes/app/components/Row';
import '../style.scss';

const chartOptions = {
    showScale: true,
    scaleShowLabels: false,
    showTooltips: false,
    responsive: true,
    maintainAspectRatio: false
};

const rawDataToChartData = (raw) => {

    const data = {labels: [], datasets: []};

    if (_.isEmpty(raw)) {
        return data;
    }

    let dataSet1 = {
        label: 'Max. registrations',
        fillColor: 'rgba(220,220,220,0.2)',
        strokeColor: 'rgba(220,220,220,1)',
        pointColor: 'rgba(220,220,220,1)',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(220,220,220,1)',
        data: []
    };
    let dataSet2 = {
        label: 'Actual registrations',
        fillColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},0.2)`,
        strokeColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},1)`,
        pointColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},1)`,
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(151,187,205,1)',
        data: []
    };

    for (let timeSlot of raw) {
        data.labels.push(serverToDisplayTimeSlot(timeSlot.begin, timeSlot.end));
        dataSet1.data.push(timeSlot.maxReg);
        dataSet2.data.push(timeSlot.actualReg);
    }

    data.datasets = [dataSet1, dataSet2];

    return data;
};

class ActualOccupancy extends Component {

    static propTypes = {
        rawData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        intl: PropTypes.object,
        fetch: PropTypes.func.isRequired,
        dateField: PropTypes.object,
        values: PropTypes.shape({
            dom: PropTypes.string,
            date: PropTypes.string
        })
    };

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.values.dom !== nextProps.values.dom || this.props.values.date !== nextProps.values.date) {
            this.fetchData(nextProps.values.dom, nextProps.values.date);
        }
    }

    fetchData = (dom, date) => {
        dom = dom || this.props.values.dom;
        date = date || this.props.values.date;
        this.props.fetch({dom, date: displayToServerDate(date)});
    };

    render() {
        const {rawData, intl:{formatMessage}, dateField} = this.props;

        return (
            <Widget
                    onRefresh={this.fetchData}
                    title={
                     <FormattedMessage id="dashboard.actualOccupancy.title" />}>

                <Row>
                    <Col s={8} offset="s2">
                        <Input s={12} type="date" label=" "
                               placeholder={formatMessage({id:'input.help.date'})}
                               format={displayDateFormat}
                               datePickerOptions={{max: new Date(new Date().getTime() + ((24 * 60 * 60 * 1000) * 7))}}
                               {...dateField}
                             />
                    </Col>
                </Row>

                {rawData.isLoading ?
                <Preloader />
                :
                    rawData.isError ?
                    <FormattedMessage id="dashboard.actualOccupancy.fetchError" />
                    :
                        rawData.length === 0 ?
                        <FormattedMessage id="dashboard.actualOccupancy.empty" />
                        :
                        <div>
                            <BarChart data={rawDataToChartData(rawData)} options={chartOptions} height="200"/>
                            <ul className="legend">
                                <li className="legend__dataset--1"><FormattedMessage id="dashboard.actualOccupancy.legend.max" /></li>
                                <li className="legend__dataset--2"><FormattedMessage id="dashboard.actualOccupancy.legend.actual" /></li>
                            </ul>
                        </div>
                }
            </Widget>
        );
    }

}

export default ActualOccupancy;